'use client'
import { BookmarkIcon, CalendarPlusIcon, ShareIcon } from 'lucide-react'
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from '@/components/ui/dropdown-menu'
import Options from '@/components/icons/Option'
import { addToCalendar } from '@/services/utils/addtocalendar'
import { HTMLProps, useState } from 'react'
import { handleShare } from '@/services/utils/share'
import { Contest } from '@/types/contest'
import { cn } from '@/services/utils/cn'

interface ShareMenuProps {
  contest: Contest
}

function formatContestToShareMenu(contest: Contest) {
  const registrationDate = contest?.open_date?.split('T')

  if (!registrationDate) {
    return {
      title: '',
      description: '',
      registrationDate: '',
    }
  }

  return {
    title: contest.title_en,
    description: contest.description_en,
    registrationDate: registrationDate[0] ? registrationDate[0].trim() : '',
  }
}

export function ShareMenuDropdown({ contest }: ShareMenuProps) {
  const { title, description, registrationDate } =
    formatContestToShareMenu(contest)
  // const [isFilled, setIsFilled] = useState(false)

  // const handleBookMarkClick = () => {
  //   setIsFilled(!isFilled) // Toggle fill state
  // }

  return (
    <DropdownMenu>
      <DropdownMenuTrigger>
        <Options />
      </DropdownMenuTrigger>
      <DropdownMenuContent>
        {/* <DropdownMenuItem onClick={handleBookMarkClick}>
          <BookmarkIcon
            color="#09090B"
            className="bg-transparent"
            width={17}
            height={17}
            fill={isFilled ? '#09090B' : 'none'}
          />
          Save
        </DropdownMenuItem> */}
        <DropdownMenuItem
          onClick={(e) => {
            e.stopPropagation()
            handleShare({
              title: title,
              text: description ?? '',
              url: `${window.location.origin}/contest/${contest.id}`,
            })
          }}
        >
          <ShareIcon
            color="#09090B"
            className="bg-transparent"
            width={17}
            height={17}
          />
          Share
        </DropdownMenuItem>
        <DropdownMenuItem
          onClick={(e) => {
            e.stopPropagation()
            addToCalendar({
              name: title,
              date: registrationDate,
            })
          }}
        >
          <CalendarPlusIcon
            color="#09090B"
            className="bg-transparent"
            width={17}
            height={17}
          />
          Add To Calendar
        </DropdownMenuItem>
      </DropdownMenuContent>
    </DropdownMenu>
  )
}

export function ShareMenuIcons({
  contest,
  ...props
}: ShareMenuProps & HTMLProps<HTMLDivElement>) {
  const { title, description, registrationDate } =
    formatContestToShareMenu(contest)
  // const [isFilled, setIsFilled] = useState(false)

  // const handleBookMarkClick = () => {
  //   setIsFilled(!isFilled) // Toggle fill state
  // }

  return (
    <div className={cn('flex items-center gap-2', props.className)} {...props}>
      {/* <button
        onClick={handleBookMarkClick}
        className={`relative inline-flex h-8 w-8 cursor-pointer items-center justify-center gap-8 rounded-full bg-black p-2 transition-transform duration-300 active:scale-75`}
      >
        <BookmarkIcon
          color="#FAFAFA"
          width={17}
          height={17}
          fill={isFilled ? '#FAFAFA' : 'none'}
        />
      </button> */}
      <button
        className={`relative inline-flex h-8 w-8 cursor-pointer items-center justify-center gap-8 rounded-full bg-black p-2 transition-transform duration-300 active:scale-75`}
        onClick={(e) => {
          e.stopPropagation()
          handleShare({
            title: title,
            text: description ?? '',
            url: `${window.location.origin}/contest/${contest.id}`,
          })
        }}
      >
        <ShareIcon color="#FAFAFA" width={17} height={17} />
      </button>
      <button
        className={`relative inline-flex h-8 w-8 cursor-pointer items-center justify-center gap-8 rounded-full bg-black p-2 transition-transform duration-300 active:scale-75`}
        onClick={(e) => {
          e.stopPropagation()
          addToCalendar({
            name: title,
            date: registrationDate,
          })
        }}
      >
        <CalendarPlusIcon color="#FAFAFA" width={17} height={17} />
      </button>
    </div>
  )
}

export function ShareMenu(props: ShareMenuProps) {
  return (
    <>
      <div className="@md:hidden">
        <ShareMenuDropdown {...props} />
      </div>
      <div className="hidden gap-[7px] @md:flex">
        <ShareMenuIcons {...props} />
      </div>
    </>
  )
}
